module.exports = __webpack_public_path__ + "static/media/tip.420d8719.png";